<template>
  <FriedRiceBody />
</template>

<script>
import FriedRiceBody from '../molecules/FriedRiceBody.vue'


export default {
  name: 'FriedRiceView',
  components: {
    FriedRiceBody,
  }
}
</script>
